import React from 'react'

export default function Loading() {
    return <div className='loading'>
            <h1>Loading....</h1>
        </div>
}